<template>
  <div
    class="next-available-time-button-wrapper"
    v-if="canUseNextAvailable && hasSelectedActivity && (noAvailableTimesForWeek || (wasClicked && isLoading))"
  >
    <button
      type="button"
      class="nk-button nk-button-slot-green"
      :class="{ 'nk-button-inactive': isLoading }"
      :disabled="isLoading"
      @click="onClick"
    >
      Hitta nästa lediga tid
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      wasClicked: false,
    };
  },
  props: {
    forceShow: {
      default: false,
    },
  },
  computed: {
    ...mapGetters(["showNextAvailableTimeButton", "noAvailableTimesForWeek"]),
    ...mapState(["activities", "ui", "cities", "locations"]),
    hasSelectedActivity() {
      return !!(this.activities && this.activities.selected && this.activities.selected.activity_id);
    },
    isLoading() {
      return !!(this.ui && this.ui.loading && this.ui.loading.times);
    },
    canUseNextAvailable() {
      const cityLocs =
        this.cities && this.cities.selected && Array.isArray(this.cities.selected.locations)
          ? this.cities.selected.locations
          : [];
      // If multiple locations in the city, require the user to pick one first.
      if (cityLocs.length > 1) {
        return !!(this.locations && this.locations.selected && this.locations.selected.id);
      }
      return true;
    },
  },
  methods: {
    ...mapActions(["getNextAvailableTimeV2"]),
    onClick() {
      this.wasClicked = true;
      if (this.ui && this.ui.loading) {
        this.ui.loading.slowNextAvailableToastArmed = true;
        this.ui.loading.slowNextAvailableToastSource = "next-button";
      }
      this.getNextAvailableTimeV2();
    },
  },
};
</script>
